import { createTheme} from "@mui/material";
// import { experimental_sx as sx } from "@mui/material"};

// import { blue, red } from '@mui/material/colors';
// import { palette } from "@mui/system";

const COLOR_TEXT_BODY = '#434F69';
const COLOR_PINK = '#D1517A';
const COLOR_YELLOW = '#FFE916';
const COLOR_PURPLE = '#563AF2';
const COLOR_BEIGE = '#D1CCCC';
const COLOR_GRAY_1 = '#B9C0CB';
const COLOR_GRAY_2 = '#C2C6CE';
const COLOR_GRAY_3 = '#F4F6F8';
// const COLOR_LIGHT_BLUE = '#B9C0CB';
const COLOR_GRAY_4 = '#F2F4F7';



const STYLE_FORM_LABEL = {
    color: COLOR_TEXT_BODY,
    fontSize: '12px',
    fontWeight: 300,
    letterSpacing: 0,
    lineHeight: '38px'
}

export const siteTheme = createTheme({
    spacing: 2,
    typography: {
        fontFamily: 'gilroy-light',
        h1: {
            fontFamily: 'gilroy-bold',
            fontWeight: 800,
            fontSize: '32px',
            letterSpacing: 0,
            lineHeight: '62px',
        },
        h2: {
            fontWeight: 800,
            fontSize: '20px',
            letterSpacing: 0,
            lineHeight: '28px',
        },
        h3: {
            fontFamily: 'gilroy-bold',
            fontWeight: 800,
            fontSize: '16px',
            letterSpacing: 0,
            lineHeight: '24px',
        },
        h4: {
            fontFamily: 'gilroy-bold',
            fontWeight: 800,
            fontSize: '24px',
            letterSpacing: 0,
            lineHeight: '24px',
        },
        datalabel : {
            fontFamily: 'gilroy-light',
            fontWeight: 500,
            fontSize: '20px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        datavalue : {
            fontFamily: 'gilroy-medium',
            fontWeight: 500,
            fontSize: '20px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        detailsDataLabel : {
            fontFamily: 'gilroy-light',
            fontSize: '16px',
            lineHeight: '20px',
            letterSpacing: 0,
            textTransform: 'capitalize',
        },
        detailsDataValue : {
            fontFamily: 'gilroy-medium',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '20px',
            letterSpacing: 0,
        },
        themeBlueHeading:{
            fontFamily: 'gilroy-bold',
            fontSize: '24px',
            lineHeight: '24px',
            letterSpacing: 0,
            color: COLOR_TEXT_BODY,
        },
        themeBlueHeadingRegular:{
            fontFamily: 'gilroy-regular',
            fontSize: '24px',
            lineHeight: '24px',
            letterSpacing: 0,
            color: COLOR_TEXT_BODY,
        },
        greyedHeading:{
            fontFamily: 'gilroy-regular',
            fontSize: '14px',
            letterSpacing: 0,
            lineHeight: '14px',
            color: COLOR_GRAY_1,
        },



    },
    palette: {
        background: {
            default: '#eee',
            paper: '#fff'
        },
        primary: {
            main: COLOR_YELLOW,
            light: COLOR_GRAY_3,
            dark: COLOR_PURPLE,
            contrastText: COLOR_TEXT_BODY
        },
        secondary: {
            main: COLOR_BEIGE,
            light: COLOR_GRAY_3,
            dark: COLOR_PURPLE,
            contrastText: COLOR_TEXT_BODY
        },
        acbutton: {
            main: COLOR_YELLOW,
            light: '#f00',
            dark: '#0f0',
            contrastText: COLOR_TEXT_BODY
        },
        text: {
            primary: COLOR_TEXT_BODY,
            secondary: COLOR_PINK,
        },
        border: {
        },
        button: {
            main: COLOR_YELLOW,
            primary: COLOR_GRAY_1,
            contrastText: COLOR_TEXT_BODY
        },
        amazingco: {
            pink: COLOR_PINK,
            yellow: COLOR_YELLOW,
            text: COLOR_TEXT_BODY,
            textlight: '#495673',
            purple: COLOR_PURPLE,
            listhighlight: COLOR_GRAY_2,
            tableheader: COLOR_GRAY_4
        }
    },
    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    h1: 'h2',
                    h2: 'h2',
                    h3: 'h3',
                    h4: 'h2',
                    h5: 'h2',
                    h6: 'h2',
                    subtitle1: 'h2',
                    subtitle2: 'h2',
                    body1: 'span',
                    body2: 'span',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
                colorPrimary: {
                    backgroundColor: '#fff',
                },
            },
            variants: [
                {
                    props: { variant: 'mainnav' },
                    styleOverrides: {
                        colorPrimary: {
                            color: COLOR_TEXT_BODY,
                            fontWeight: 300,
                            backgroundColor: '#eee',
                        },
                    },
                },
            ]
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    color: COLOR_TEXT_BODY,
                    fontWeight: 300,
                    "&.Mui-selected": {
                        color: '#0f0',
                        fontWeight: 800
                    }
                },

                indicator: {
                    backgroundColor: COLOR_TEXT_BODY,
                    height: 3,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: COLOR_TEXT_BODY,
                    fontWeight: 300,
                    fontSize: '20px',
                    letterSpacing: 0,
                    lineHeight: '28px',
                    "&.Mui-selected": {
                        color: COLOR_TEXT_BODY,
                        fontWeight: 800
                    }
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: { ...STYLE_FORM_LABEL }

            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: COLOR_GRAY_4,
                    fontWeight: 800
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    '&:hover': {
                        color: 'white',
                    }
                },
                containedSecondary: {
                    '&:hover': {
                        color: 'white',
                    }
                },
            }
        },
        MuiTableRow: {
            styleOverrides:{
                root: {
                    '&:hover': { backgroundColor: "#ddd" }
                }
            }
        }

    },
})

/*          
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#ff4400',
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            light: '#0066ff',
            main: '#0044ff',
            // dark: will be calculated from palette.secondary.main,
            contrastText: '#ffcc00',
        },
        neutral: {
            main: '#64748B',
            contrastText: '#fff',
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,

    },

        button: {
            fontSize: '1rem',
        },
        subtitle1: {
            fontSize: 12,
        },
        body1: {
            fontWeight: 500,
        },
        button: {
            fontStyle: 'italic',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    // Some CSS
                    fontSize: '1rem',
                },
            },
            styleOverrides: ({ ownerState }) => ({
                ...(ownerState.variant === 'contained' &&
                    ownerState.color === 'primary' && {
                    backgroundColor: '#202020',
                    color: '#fff',
                }),
            }),
            variants: [
                {
                    props: { variant: 'dashed' },
                    style: {
                        textTransform: 'none',
                        border: `2px dashed ${blue[500]}`,
                    },
                },
                {
                    props: { variant: 'dashed', color: 'secondary' },
                    style: {
                        border: `4px dashed ${red[500]}`,
                    },
                },
            ],
        },
        MuiButtonBase: {
            defaultProps: {
                // The props to change the default for.
                disableRipple: true, // No more ripple, on the whole application 💣!
            },
        },

        MuiSlider: {
            styleOverrides: {
                valueLabel: ({ ownerState, theme }) => ({
                    ...(ownerState.orientation === 'vertical' && {
                        backgroundColor: 'transparent',
                        color: theme.palette.grey[500],
                    }),
                }),
            },
        },
        MuiChip: {
            styleOverrides: {
                root: sx({
                    px: 1,
                    py: 0.25,
                    borderRadius: 1,
                }),
                label: {
                    padding: 'initial',
                },
                icon: sx({
                    mr: 0.5,
                    ml: '-2px',
                }),
            },
        },
        MuiButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiFilledInput: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFormControl: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFormHelperText: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputBase: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiListItem: {
            defaultProps: {
                dense: true,
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFab: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTextField: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiToolbar: {
            defaultProps: {
                variant: 'dense',
            },
        },
*/

